module.exports = __webpack_public_path__ + "static/media/re-kyb-alert.775a0860.svg";